// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgWaterWarmIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <g clipPath="url(#WaterWarmIcon_svg__a)">
      <path
        fillRule="evenodd"
        d="M12 3c.36 0 .7.16.93.44C13.56 4.241 19 11.41 19 15c0 3.93-3.07 7-7 7s-7-3.07-7-7c0-3.6 5.44-10.769 6.07-11.56.23-.28.57-.44.93-.44m.36 7.15c-.2-.2-.51-.2-.71 0-1.3 1.3-1.3 3.41 0 4.71.91.9.91 2.38 0 3.29-.2.2-.2.51 0 .71a.485.485 0 0 0 .7 0c1.3-1.3 1.3-3.41 0-4.71h.01c-.91-.9-.91-2.38 0-3.29.2-.2.2-.51 0-.71m-3 .99c-.2-.2-.51-.2-.71 0a2.63 2.63 0 0 0 0 3.71c.31.31.48.71.48 1.15s-.17.84-.48 1.15c-.2.2-.2.51 0 .71a.485.485 0 0 0 .7 0 2.63 2.63 0 0 0 0-3.71h.01c-.31-.31-.48-.71-.48-1.15s.17-.84.48-1.15c.2-.2.2-.51 0-.71m6 0c-.2-.2-.51-.2-.71 0a2.63 2.63 0 0 0 0 3.71c.31.31.48.71.48 1.15s-.17.84-.48 1.15c-.2.2-.2.51 0 .71a.485.485 0 0 0 .7 0 2.63 2.63 0 0 0 0-3.71h.01c-.31-.31-.48-.71-.48-1.15s.17-.84.48-1.15c.2-.2.2-.51 0-.71"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="WaterWarmIcon_svg__a">
        <path d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </g>
);
export default SvgWaterWarmIcon;
SvgWaterWarmIcon.displayName = 'SvgWaterWarmIcon';
